import { render, staticRenderFns } from "./DetailsPane.vue?vue&type=template&id=38a8eaaf&scoped=true"
import script from "./DetailsPane.vue?vue&type=script&lang=ts"
export * from "./DetailsPane.vue?vue&type=script&lang=ts"
import style0 from "./DetailsPane.vue?vue&type=style&index=0&id=38a8eaaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8eaaf",
  null
  
)

export default component.exports